import React, { useState, useEffect } from 'react';
import { scrollToTop } from '../utils/scrollUtils';

const ScrollToTopButton = ({ 
  threshold = 300, 
  className = '',
  position = 'bottom-right',
  size = 'medium'
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  const handleClick = () => {
    scrollToTop('smooth');
  };

  const positionClasses = {
    'bottom-right': 'bottom-6 right-6',
    'bottom-left': 'bottom-6 left-6',
    'bottom-center': 'bottom-6 left-1/2 transform -translate-x-1/2',
    'top-right': 'top-6 right-6',
    'top-left': 'top-6 left-6'
  };

  const sizeClasses = {
    'small': 'w-10 h-10',
    'medium': 'w-12 h-12',
    'large': 'w-14 h-14'
  };

  const iconSizeClasses = {
    'small': 'w-4 h-4',
    'medium': 'w-5 h-5',
    'large': 'w-6 h-6'
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      className={`
        fixed ${positionClasses[position]} ${sizeClasses[size]}
        bg-apn-blue hover:bg-blue-700 text-white rounded-full shadow-lg
        flex items-center justify-center transition-all duration-300
        hover:scale-110 focus:outline-none focus:ring-2 focus:ring-apn-blue focus:ring-offset-2
        z-50 ${className}
      `}
      title="Scroll to top"
      aria-label="Scroll to top"
    >
      <svg 
        className={iconSizeClasses[size]} 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M5 10l7-7m0 0l7 7m-7-7v18" 
        />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;
